
<div class="modal-overlay">
  <div class="modal-content">
    <button class="btn-delete" @click="$emit('delete')">
      <svg-icon
        icon-name="ic-corbeille"
        color="$couleur-primaire"
        className="iconeCorbeille"
      ></svg-icon>
    </button>
    <button class="btn-close" @click="$emit('close')">
      <svg-icon
        icon-name="ic-fermer1"
        color="$couleur-primaire"
        className="iconeFermer"
      ></svg-icon>
    </button>
    <div class="modal-body">
      <span>{{ message.createDate }}</span
      ><br />
      <h3>{{ messagesBienJouer[message.messageCode].msgTitre }}</h3>
      <br /><br />
      <p>{{ messagesBienJouer[message.messageCode].msgDetail }}</p>
    </div>
  </div>
</div>
